import { module } from 'angular';

import { GLOBAL_SEARCH_COMPONENT } from './globalsearch.component';

import './globalSearch.less';

export const GLOBAL_SEARCH = 'spinnaker.core.search.global';
module(GLOBAL_SEARCH, [
  GLOBAL_SEARCH_COMPONENT
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/search/global/globalSearch.module.ts